/* tslint:disable:only-arrow-functions */
/* tslint:disable:no-any */

import 'reflect-metadata';

const metadataKey = Symbol('responsiveStyleInput');

export interface IResponsiveStyleInputConfig {
  predefinedMap?: Map<string, string>;
  cssVariable?: boolean;
  isBoolean?: boolean;
  isNumber?: boolean;
  defaultValue?: string;
  // validators in future
}

/**
 * The decorator to store metadata information of a component to be consumed by AbstractContentComponent
 *
 * @param props {
 * predefinedMap: Is a map to give better options to consumers. It can map
 *                   human readable strings to actual values
 *
 * cssVariable: If set to true the decorator will create css variables for the input
 *
 * boolean: If set to true the decorator will check with hasAttribute. Cannot be used with cssVariable
 * }
 */
export function ResponsiveInput(props?: IResponsiveStyleInputConfig) {
  const reflectMetadataFactory = Reflect.metadata(metadataKey, props ?? {});
  return function (protoTarget: any, property: string) {
    protoTarget[property] = undefined; // populate proto for accessing in future
    return reflectMetadataFactory(protoTarget, property);
  };
}

export function getResponsiveInput(
  target: any,
  property: string,
): IResponsiveStyleInputConfig {
  return Reflect.getMetadata(metadataKey, target, property);
}
